import { ReactNode, useEffect, useState } from 'react';
import CheckIcon from '@mui/icons-material/Check';

import ContentLayout from "~/components/ContentLayout";
import { trans } from "~/utils/trans";
import { classNames } from "~/utils/utils";

import "./style.less";

// obrazky na leve strane, stridaji se nahodne
const HERO_IMAGES = ["1.jpeg", "2.jpeg", "3.jpeg"].map(file => `https://app.doitforyourself.cz/img/loginPage/${file}`);
const HERO_INTERVAL = 7000;
// dalsi obrazek se zacne stahovat az tolik ms pred prolnutim (ne vsechny hned pri nacteni stranky)
const HERO_PRELOAD_AHEAD = 2500;
const HERO_POINTS = ["heroPoint1", "heroPoint2", "heroPoint3"];

function randomIndex(exclude = -1): number {
	const index = Math.floor(Math.random() * HERO_IMAGES.length);

	return index === exclude && HERO_IMAGES.length > 1 ? randomIndex(exclude) : index;
}

interface IAuthLayout {
	children: ReactNode;
}

// rozlozeni prihlaseni a registrace - vlevo (na telefonu nahore) fotky receptu, vpravo formular
export default function AuthLayout({
	children,
} : IAuthLayout) {
	const [heroIndex, setHeroIndex] = useState(() => randomIndex());
	// obrazky, ktere uz jsou stazene - jen ty dostanou background-image
	const [loaded, setLoaded] = useState<Array<number>>(() => [heroIndex]);

	useEffect(() => {
		const nextIndex = randomIndex(heroIndex);
		let nextReady = loaded.includes(nextIndex);
		let switchTimeout: ReturnType<typeof setTimeout> = null;
		const preloadTimeout = setTimeout(() => {
			const img = new Image();

			img.onload = () => {
				nextReady = true;
				setLoaded(prev => (prev.includes(nextIndex) ? prev : [...prev, nextIndex]));
			};
			img.src = HERO_IMAGES[nextIndex];
		}, HERO_INTERVAL - HERO_PRELOAD_AHEAD);

		// prolnuti az je dalsi obrazek stazeny, jinak se zkusi znovu za chvili (pomale pripojeni)
		function trySwitch() {
			if (nextReady) {
				setHeroIndex(nextIndex);
			} else {
				switchTimeout = setTimeout(trySwitch, HERO_PRELOAD_AHEAD);
			}
		}

		switchTimeout = setTimeout(trySwitch, HERO_INTERVAL);

		return () => {
			clearTimeout(preloadTimeout);
			clearTimeout(switchTimeout);
		};
	}, [heroIndex]);

	const mainContent = <div className="authLayout" slot="mainContent">
		<section className="authLayout__hero">
			{ HERO_IMAGES.map((src, index) => <div
				key={src}
				className={classNames(["authLayout__heroImg", index === heroIndex ? "authLayout__heroImg--active" : ""])}
				style={loaded.includes(index) ? { backgroundImage: `url("${src}")` } : undefined}
			/>)}
			<div className="authLayout__heroText">
				<h2>{trans("loginPage.heroTitle")}</h2>
				<ul>
					{ HERO_POINTS.map(point => <li key={point}>
						<CheckIcon className="authLayout__check" />
						{trans(`loginPage.${point}`)}
					</li>)}
				</ul>
			</div>
		</section>
		<section className="authLayout__formArea">
			<div className="authLayout__controls">
				{children}
			</div>
		</section>
	</div>;

	return <ContentLayout className="layout__auth" mainContent={mainContent} />;
}
